export default {
	"autoreport": {
		"algoModel": "รูปแบบอัลกอริทึม",
		"templateCode": "เนื้อหาเทมเพลต",
		"emailTitle": "หัวข้อจดหมาย",
		"fileType": "แบบฟอร์มเอกสารแนบ",
		"batchOperationTips": "ตรวจสอบข้อมูลที่ต้องดำเนินการ",
		"tabPanleName1": "ข้อมูลรายงาน",
		"daily": "รายวัน",
		"emailValidataMsg1": "ที่อยู่อีเมล์ไม่ถูกต้อง",
		"emailValidataMsg2": "ที่อยู่อีเมล์ได้รับการลงทะเบียนแล้ว",
		"emailValidataMsg3": "ความยาวของที่อยู่อีเมล์ต้องไม่เกิน 500 ตัวอักษร"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/autoreport/autoreport.js